export default __webpack_public_path__ + "static/media/cooperativism.22cfdcbd.jpeg";